import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { getHostOrganizerName } from "../../home/components/meetigs/helpers"

import type { MeetingRoomBooking } from "../meetingRoomsTypes"

const useStyles = makeStyles()(() => ({
    root: {
        minWidth: 0,
    },
}))

type MeetingRoomTimelineBookingMetaProps = Readonly<{
    booking: MeetingRoomBooking
}>

export function MeetingRoomTimelineBookingMeta({ booking }: MeetingRoomTimelineBookingMetaProps) {
    const { classes } = useStyles()
    const ownerName = getHostOrganizerName([...booking.organizers])

    return (
        <Stack
            direction="row"
            spacing=".25rem"
            className={classes.root}
            divider={
                <Typography variant="body2" color="text.secondary">
                    &middot;
                </Typography>
            }
        >
            {ownerName && (
                <Typography variant="body2" noWrap color="text.secondary">
                    {ownerName}
                </Typography>
            )}
            {booking.participants !== undefined && (
                <LocalizedStrict
                    id="service-center-meeting-rooms-booking-participants"
                    vars={{ participants: booking.participants }}
                >
                    <Typography variant="body2" noWrap color="text.secondary">
                        {booking.participants}
                    </Typography>
                </LocalizedStrict>
            )}
            {booking.hasCatering && (
                <LocalizedStrict id="service-center-meeting-rooms-booking-catering-chip">
                    <Typography variant="body2" noWrap color="text.secondary">
                        Catering
                    </Typography>
                </LocalizedStrict>
            )}
        </Stack>
    )
}
